const de = {
  title: 'Stellenangebote',
  detailTitle: 'Stellenangebot',
  searchbarTitle: 'Titel',
  jobTypes: {
    1: 'Sonstiges',
    2: 'Werkstudententätigkeit',
    3: 'Studien- und Abschlussarbeit',
    4: 'Industrielle Projektarbeit',
    5: 'Auslandspraktikum',
    6: 'Jobeinstieg und Trainee',
    7: 'Abschlussarbeit',
    8: 'Freiwilliges Praktikum',
    9: 'Praktikum',
    10: 'Duales Studium',
    11: 'Duales Studium (mit vertiefter Praxis)',
    12: 'Studentische Hilfskraft',
    13: 'Studentenjob',
    14: 'Hilfskraft Hochschule'
  },
  openFailed: 'Stellenangebot konnte nicht geöffnet werden',
  notFound: 'Stellenangebot konnte nicht gefunden werden',
  updatedOn: 'Aktualisiert am',
  postedOn: 'Eingestellt am ',
  start: 'ab',
  downloadDescription: 'Beschreibung',
  downloadAttachement: 'Anhang',
  changeJobType: {
    disabledStudentAssistantJobTypeTooltip:
      'Studentische Hilfskraft ist nur für interne Stellenausschreibungen verfügbar.',
    disabledJobTypeTooltip:
      'Entweder ist ihr Zeitraum zum Wechsel abgelaufen oder Sie können nicht selbst in eine kostenpflichtige Kategorie wechseln. Bitte wenden Sie sich hierfür an das Career Center. E-Mail: careercenter@th-rosenheim.de',
    cantChangeFromPaidTooltip:
      'Der Typ eines kostenpflichtigen Stellenabgebots kann nur innerhalb der ersten 3 Tage nach Erstellen geändert werden.',
    changeFromFreeToPaidJobTypeInfoBoxTitle: 'WICHTIG!',
    changeFromFreeToPaidJobTypeInfoBox:
      'Wenn Sie den Typ der Stellenausschreibung in einen kostenpflichtigen ändern, bleibt der laufende Veröffentlichungszeitraum unverändert. Sie müssen somit auch den Zeitraum bezahlen, in dem die Stellenanzeige noch unter einem anderen Typ gelistet war!'
  },
  inspectArticle: 'Beitraginspektion',
  startDate: 'Startdatum',
  createdAt: 'Aufgegeben am',
  activatedAt: 'Freigeschaltet am',
  jobOffer: 'Stellenangebot',
  jobOffers: 'Stellenangebote',
  openCompanyProfile: 'Firmenprofil öffnen',
  forbidden: 'Sie können nur die Stellenangebote Ihrer eigenen Firma ansehen.',
  deleteNotAllowed: 'Aktive Jobangebote können nicht gelöscht werden',
  publication: 'Veröffentlichung',
  zipcode: 'PLZ',
  radius: 'Radius',
  applyNow: 'Jetzt bewerben'
};

export default de;
export type JobOffersTranslation = typeof de;
